module.exports = __webpack_public_path__ + "static/mrcs-demo-web-1-5f92c94c1c2654c96012a303a67b8342.mp4";